import { Theme, createStyles } from '@material-ui/core';
import { green, grey, red } from '@material-ui/core/colors';
import { StyleRules } from '@material-ui/core/styles/withStyles';
import { app } from '../../../../theme';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    width: 960,
    height: `calc(100vh - ${theme.spacing(29)}px)`,
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  table: {
    overflowX: 'auto',
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    },
  },
  tableHeaderRow: app.table.headerRow(theme),
  tableHeaderCell: app.table.headerCell(theme),
  tableRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(0.5),
  },
  tableRowSub: {
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  tableCell: {
    ...app.table.cell(theme),
    whiteSpace: 'nowrap',
    paddingBottom: theme.spacing(0.5),
  },
  tableEvenRow: {
    ...app.table.eventRow(theme),
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      borderBottom: `${theme.spacing(0.5)}px solid ${theme.palette.background.default}`,
    },
  },
  tableOddRow: {
    ...app.table.oddRow(theme),
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      borderBottom: `${theme.spacing(0.5)}px solid ${theme.palette.background.default}`,
    },
  },
  tableCellCenter: {
    justifyContent: 'center',
  },
  tableGrid: app.table.grid(),

  details: {
    padding: theme.spacing(2),
  },
  orderCancelled: {
    color: red[900],
    textDecoration: 'line-through',
    whiteSpace: 'nowrap',
  },
  orderProcess: {
    color: grey[600],
    whiteSpace: 'nowrap',
  },
  orderNormal: {
    color: green[700],
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  orderAbnormal: {
    color: red.A700,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  statusBox: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default styles;
